export default "__VITE_ASSET__ClrvnPt___"